import { defineStore } from 'pinia';

export const useLayoutStore = defineStore({
  id: 'layout',
  state: () => ({
    navigationSideBar: true,
    mobileNavigationSideBar: true,
    settingsNavigationSideBar: true,
    header: {
      isOpen: true,
    },
    footer: {
      isOpen: true,
    },
  }),
  actions: {
    toggleNavigationSideBar() {
      this.navigationSideBar = !this.navigationSideBar;
    },
    toggleMobileNavigationSideBar() {
      this.mobileNavigationSideBar = !this.mobileNavigationSideBar;
    },
    toggleSettingsNavigationSideBar() {
      this.settingsNavigationSideBar = !this.settingsNavigationSideBar;
    },
    toggleHeader(isOpen) {
      this.header.isOpen = isOpen;
    },
    toggleFooter(isOpen) {
      this.footer.isOpen = isOpen;
    },
  },
});
